import { DotLabel } from "components/Dot";
import { NoDataAvailableDiv } from "components/NoDataAvailableDiv";
import { Panel } from "components/panels";
import moment from "moment";
import classNames from "classnames";
import React from "react";
import { formatShortDate } from "utilities";
import { useCustomQuery } from "utilities/hookutils";
import { findEnumLabel } from "utilities/enumutils";

interface Props {
  country: server.dto.Countries
}

export const VatRatesPanel = (props: Props) => {
  const api = useCustomQuery({
    queryKey: ["vatRatesForCountry", props.country],
    queryFn: async () => window.CoreApi.VatRate.Paginated({
      country: props.country,
      page: 1,
      perPage: 50,
    }),
  });

  const isLoading = api.isLoading || api.isFetching;
  const vatRates = api.data?.data?.data ?? [];

  return <Panel
    panelClassName="s1_related-feature-panel"
    articleId={serverReference.supportArticleIds.vatRates}
    title={RESX.VatNumber.VATRates}
    isLoading={isLoading}
    hasError={api.isError || api.data?.data?.hasErrors}
  >
    {vatRates.length === 0 && <NoDataAvailableDiv />}
    {vatRates.length > 0 && <div className="list-with-gaps card-layout">
      <div className="list-with-gaps-body">
        {vatRates.map((vatRate) => <VatRateRow key={vatRate.vatRateId} vatRate={vatRate} />)}
      </div>
    </div>}
  </Panel>
}

const VatRateRow = ({ vatRate }: { vatRate: server.dto.VatRate }) => {
  const start = moment.utc(vatRate.start);
  const end = vatRate.end ? moment.utc(vatRate.end) : null;
  const isActive = !end || end.isAfter(moment.utc());

  return <div className={classNames("vat-rates-sidepanel-row flex-column padding-larger", {
    "vat-rates-sidepanel-row-disabled": !isActive,
  })}>

    <div>
      <div>
        {`${vatRate.internalName} (${vatRate.percentageFormatted})`}
      </div>
      <div className="text-sublabel">
        {findEnumLabel(vatRate.type, serverReference.vatRateTypes)}
      </div>
    </div>

    <div className="text-sublabel">
      <DotLabel
        dotColor={isActive ? serverReference.constants.colors.green : serverReference.constants.colors.red}
      >
        {formatShortDate(start)}{end && ` - ${formatShortDate(end)}`}
      </DotLabel>
    </div>
  </div>

}